import studyaudio from '../studyaudio/StudyAudio.vue'
import studypdf from '../studypdf/StudyPdf.vue'
import studypicture from '../studypicture/StudyPicture.vue'
import studyvideo from '../studyvideo/StudyVideo.vue'
import studydiscussion from '../studydiscussion/StudyDiscussion.vue'
import classexam from '../classexam/ClassExam.vue'
import exercise from '../exercise/exercise.vue'
// import pdf from 'vue-pdf'
export default {
    components:{studyaudio,studypdf,studypicture,studyvideo,studydiscussion,classexam,exercise},
    data() {
        return {
			leftTitleData:[],
			img:{
				time:require("@/assets/images/time.png"),
				user:require("@/assets/images/user.png"),
				tip:require("@/assets/images/tip.png"),
			},
            nowTime:'0',
            allTime:'0',
            cs:0,
            id:'',
            time:'',
            isCollapse: true,
            activeProgress:'',
            //学习的类型，1是视频，2是习题，3是音频，4是world文档，5是图片
            type:0,
            //图片的src
            scr:null,
            //pdf的路径
            pdf:null,
            //点击的课程章节标志
            chapterIndex_bz:'',
            itemIndex_bz:'',
            //全部看完标志
            qunbukanwanBz:false,
            // 资源名称
            resourceName:'',
            
          
            project:[
              
            ],
            //活动
            active:[{
                activitie_name: '',
                resources:[{}],
                activeState:''
            }],
            // 活动进度
            activePlan:[],
            //继续学习
            continuechapter:{
                chapterIndex:null,
                itemIndex:null,
                className:'',
                items_resources:'',
                activeIndex:'',
             
            },
            
            //标记哪一个资源
            itemIndex:0,//节资源标记
            chapterIndex:0,//章标记
            activeIndex:0,//活动标记 传过来的值
            taskIndex:0,//任务标记 传过来的值
            task_name:'',
            progressFlag:0,

            activeState:null,
            taskState:null,
            
            project_id:'',
            purchased_id:'',
            dataFlag:null,
            // 资源进度数组 0:未读 1：在读 2：已完成
            resourcesProgress:{
                name:'',
                resources:[],
                progress:'',
                state:'',
                currentTime:''
            },
            currenttime:0,
            projectProgress:0,

            sumResource:0,
     
            //进度信息保存的定时器
            saveProcessInfo: null,
            
            //右侧弹出的箭头图标改的标识
            arrowIcon: true,
            //活动进度
            ActivitySchedule:0,
             //任务进度
            TaskSchedule:0,
            // 产品id
            goodsId:'',
            //视频vid
            videoUrl: '',
            //视频对象
            videoObj: '',
            //音频对象
            audioObj:'',
            //任务数组
            taskArr:[],
            audioBZ:0,
            //课后习题完成标志 2 表示完成
            exerciseBz:0,
            ClasseXamBZ:0,
            src: require('../../assets/images/arrows-right.png'),
            //定时器
            timer: null,
            //图片宽度
            imgWidth:90,
            //定时器计数标志30秒保存一次视频
            TimerBz:0,
            //习题字数限制
            exercise_num:15,
            //评分规则
            proportion:[],
            //分数
            totalPoints:'',
            LastProgress:0,//上一次视频进度
            LastTimer:0,//上一次视频播放时间

            
        }

    },
    methods: {
    ////////////////////////////////////////////////////////////////获取数据方法//////////////////////////////////////////////////////////////
    //查询项目大纲
    getData(){
            
        this.$post('project_tasks/search_group_by_task', {
            token: this.$store.state.id,
            offset:0 , 
            length: 999, 
            project_id: this.project_id
        }).then(res => {
        this.project = res.data.result.data.map((res)=>{
                for(let i=0;i<res.task_activities.length;i++){
                    res.task_activities[i].resources = JSON.parse(res.task_activities[i].resources)
                }  
                return res
        })
            this.task_name = this.project[0].task_name//获取任务名
            this.taskArr = this.project[this.taskIndex].task_activities
            this.active[0] = this.project[this.taskIndex].task_activities[this.activeIndex]
            this.active[0].resources = this.project[0].task_activities[0].resources;//获取活章节
            
            this.active[0].activitie_name = this.project[0].task_activities[0].activitie_name;//获取活动名
            this.active[0].activite_sort = this.project[this.taskIndex].task_activities[this.activeIndex].activite_sort;//获取活动排序
            this.id = this.active[0].resources[0].items[0].resources[0]//获取任务资源
            this.huoqujinduarr()
             // this.CalculatingActivityProgress()//计算活动进度
             this.ComputingTask()//计算任务进度
            //页面标题
            document.title = this.active[0].activitie_name;
            // console.log('id',this.id )
            // console.log('项目大纲',this.project )
            this.chapterIndex_bz=0
            this.itemIndex_bz=0
            // 获取视频资源
            this.$post('resources/get',{token: this.$store.state.id,id:this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz].resources[0]}).then(res=>{
                let url=res.data.result.data;
                this.type = res.data.result.type;
                this.time = this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz].currentTime
                this.getType(url)
            })
            this.getCodePoints()//插入评分规则
        })

    },
    getRate(){
        this.cs=1
        this.$post('purchased/get',{token:this.$store.state.id,id:this.purchased_id,}).then(res=>{
            if(res.data.result.rate !=null && res.data.result.rate !=''){
				
				this.leftTitleData = res.data.result
				// console.log(this.leftTitleData)
                // console.log('获取josn大纲')
                this.project = JSON.parse(res.data.result.rate)
                // console.log('项目大纲信息1',this.project )
                this.task_name = this.project[this.taskIndex].task_name;
                this.taskArr = this.project[this.taskIndex].task_activities
                // //获取活动上次进行的活动索引
                // this.activeIndex = this.project[this.taskIndex].lasttime.activeIndex
                this.active[0] = this.project[this.taskIndex].task_activities[this.activeIndex]
                this.active[0].resources = this.project[this.taskIndex].task_activities[this.activeIndex].resources;//获取活动章節
                this.active[0].activitie_name = this.project[this.taskIndex].task_activities[this.activeIndex].activitie_name;//获取活动名
                this.active[0].activite_sort = this.project[this.taskIndex].task_activities[this.activeIndex].activite_sort;//获取活动排序
                this.huoqujinduarr()
               
               // this.CalculatingActivityProgress()//计算活动进度
                this.ComputingTask()//计算任务进度
                 //页面标题
                document.title = this.active[0].activitie_name;
                // console.log('活动',this.active[0].resources)
                if(this.getjindu()) {//查看资源播放位置
                    this.type = 99 //活动已完成
                    this.itemIndex_bz = 0
                    this.chapterIndex_bz = 0
                    this.qunbukanwanBz = true //全部看完
                   return
                } 
                this.getType()// 获取资源
            }else {
                this.getData()
                // console.log('获取原目录大纲')
            }
            this.getCodePoints()//插入评分规则
        })
    },
    // 获取资源
    getType(){
        this.$post('resources/get',{
            token: this.$store.state.id,
            id:this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz].resources[0]
        }).then(res=>{
            this.type = res.data.result.type;
            let url=res.data.result.data;
            this.id = this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz].resources[0]

            if(this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz].currentTime !=null){
                this.time = this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz].currentTime
            }else{
                this.time = 0
            }      
            // console.log('type',this.type)
            if(this.type == 1){
                if(this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz].progress){
                    this.LastProgress = this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz].progress
                    this.LastTimer = this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz].currentTime
                }else{
                    this.LastProgress = 0
                    this.LastTimer = 0
                }
                // console.log('获取资源时取到的进度', this.LastProgress)
                // console.log('获取资源时取到的时间', this.LastTimer)
                this.videoPlayer(url,this.time) 
            }else if(this.type == 3){
                this.videoUrl = this.musicUrl + url
                if(this.time == null){
                    this.time=0
                }
                // console.log("time:",this.time)
                this.audioObj.src = this.videoUrl
                this.audioObj.currentTime = this.time
            }else if(this.type == 4){
                this.$refs.wodr.getResourse(this.id)
            }else if(this.type == 5){
                this.videoUrl = this.imgUrl + url
            }else if(this.type == 7){
                let rule = this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz].rule
                if(2 == rule){//规则等于2 限制简答题输入500字
                    this.exercise_num = 500
                }
            }
            if(this.type == 4 || this.type == 5){
                this.otherLeaveVideo()//保存进度  文档和图片点击进入既体现完成状态
                // console.log(" 文档和图片点击进入既体现完成状态")
            }
            // console.log("获取资源完成")
        })
    },
    // 查询课程类型
    judgeBuy(){
            let is_project
            this.$post('products/get', { //返回is_project =1 是项目式  0 是云课程
                token: this.$store.state.id,
                id: this.product_id,
            }).then(res => {
                // console.log('判断课程类型',res)
                // console.log('判断课程类型',res.data.result.is_project)
                is_project = res.data.result.is_project
                return is_project
            })
    },
    ////////////////////////////////////////////////////////////end:获取数据方法//////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////跳转页面方法//////////////////////////////////////////////////////////////////
   //跳转项目大纲
   tolessonstudy() {
    //    alert(1);
    //    console.log('跳转项目大纲')
        this.$router.push({
            path: '/lessonstudy',
            query: {
                id: this.product_id
            }
        })
    },


    //跳转项目首页
    topojecthomepage() {
        this.$router.push({
            path: '/pojecthomepage',
            query: {
                id: this.project_id
            }
        })
    },

    //回课程学习页面
    toClassStudy() {
        this.otherLeaveVideo()//保存进度
        if(this.judgeBuy()==0){//跳云课程界面
            this.$router.push({
                path: '/classstudy',
                query: {
                    id: this.product_id
                }
            })
        }else{//跳项目式界面
            this.$router.push({
                path: '/lessonstudy',
                query: {
                    id: this.product_id
                }
            })
        }
    
    },
    ////////////////////////////////////////////////////////////end:跳转页面方法//////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////逻辑处理方法//////////////////////////////////////////////////////////////
     //保存进度
     otherLeaveVideo(ov){
        //关闭定时器
        clearInterval(this.timer)
        this.timer = null
        
        // console.log("保存进度")
        let data
        let time = 0
        if(this.type == 1 || this.type == 3 || this.type == 6 || this.type == 2 || this.type == 7){
            if(this.type == 3){this.audioObj.pause()}//关闭音频
            if(ov!=null){//播放完毕
                data = 1
                if(this.type == 1){
                    time = this.videoObj.j2s_getDuration()
                }else if(this.type == 3){
                    time = this.audioObj.currentTime
                }
            }else{
                if(this.type == 1){
                     data = this.videoObj.j2s_getCurrentTime()/this.videoObj.j2s_getDuration()
                     time = this.videoObj.j2s_getCurrentTime()
                     if(data<this.LastProgress){
                          data = +this.LastProgress
                          time = this.LastTimer
                        //   console.log('进度小于上次，保存最大值！',data,time)
                     }
                    
                }else if(this.type == 3){
                    data = this.audioObj.currentTime/this.audioObj.duration
                    time = this.audioObj.currentTime
                }else if(this.type == 6 && this.audioBZ==2){
                    // console.log('讨论区进度完成！')
                    data =1
                    time =1
                    this.audioBZ=0
                }else if(this.type == 7 && this.exerciseBz==2){
                    // console.log('课后习题进度完成！')
                    data =1
                    time =1
                    this.exerciseBz=0
                }else if(this.type == 2 && this.ClasseXamBZ==2){
                    // console.log('考试完成！')
                    data =1
                    time =1
                    this.ClasseXamBZ=0
                }
            }
        }else{
            data =1
            time =1
        }
     
        // console.log('leixng:',this.type)
        // console.log('chapterIndex_bz',this.chapterIndex_bz)
        // console.log('itemIndex_bz',this.itemIndex_bz)
        // console.log('time',time)
        if( time!=0 && this.type!=0 && this.type!=99 ){
            //给活动数组赋值
            if(data == 1){
                this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz].progress = data.toFixed(2)
                this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz].currentTime = time
                this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz].state =2
                // console.log('保存活动---',this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz])
            }else{
                // console.log('.toFixed(2)',data)
                this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz].progress = data.toFixed(2)
                this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz].currentTime = time
                if(this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz].state != 2){
                     this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz].state =1
                }
                // console.log('保存活动-',this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz])
            }

            //计算章进度
            if(this.CalculateChapterProgress(this.active[0].resources[this.chapterIndex_bz].items)){
                this.active[0].resources[this.chapterIndex_bz].state=2
                // console.log('章已完成')
            }
            
           
            if(this.getjindu('chaxun')){//活动完成
                this.active[0].activeState = 2;//活动进度状态赋值
                // console.log('活动已完成')
                let huodong = true 
                let activeIndex
                //判断相同排序的活动是否完成  返回 true   表示未完成
                for(let i=0;i<this.project[this.taskIndex].task_activities.length;i++){
                    if(this.project[this.taskIndex].task_activities[i].activite_sort == this.project[this.taskIndex].task_activities[this.activeIndex].activite_sort ){
                        activeIndex =  i
                        if(this.project[this.taskIndex].task_activities[i].activeState == 1 && this.activeIndex!=i){
                             huodong = false
                            //  console.log('还有相同排序的活动没有完成！')
                             break
                        }
                    }
                }
                if(huodong){
                    // console.log('activeIndex',activeIndex)
                    if(this.project[this.taskIndex].task_activities.length-1 == activeIndex){//判断是否是最后一个活动
                        // console.log('当前任务已完成')
                        this.project[this.taskIndex].taskState= 2;
                        let huodong1 = true 
                        let activeIndex1
                        //判断同等序号还有没有任务未完成  有则不改变下个任务的状态
                        for(let i=0;i<this.project.length;i++){
                            if(this.project[i].sort == this.project[this.taskIndex].sort ){
                                activeIndex1 =  i
                                if(this.project[i].taskState == 1 && this.taskIndex !=i){
                                     huodong1 = false
                                    //  console.log('还有相同排序的任务没有完成！')
                                     break
                                }
                            }
                        }
                        if(huodong1){
                            if(this.project.length-1 > activeIndex1){//判断是否还有任务 有就给下个任务进度赋值
                                // console.log('还有下个任务')
                                this.project[Number(activeIndex1)+1].taskState= 1;
                                this.project[Number(activeIndex1)+1].task_activities[0].activeState = 1
                            }else{
                                // console.log('所有任务完成')
                            }
                        }
                       
                    }else{
                            // console.log('任务未完成')
                            this.project[this.taskIndex].task_activities[Number(activeIndex)+1].activeState = 1
                            this.project[this.taskIndex].taskState= 1;             
                    }
                }
            }else{
                this.active[0].activeState = 1;//活动进度状态赋值
                this.project[this.taskIndex].taskState= 1;
            }

            
            // 修改数组触发视图变化
            this.active.push({ message: 'Baz' })
            this.active.pop()
            //计算章进度
            
            
            let obj = [];
            this.project[this.taskIndex].task_activities[this.activeIndex] = this.active[0] ;
            
            obj = this.project;
            //  console.log("---------------",this.SaveTheProgress()) 
            let json1 = JSON.stringify(obj)
            this.$post('purchased/sumbitRate',{token:this.$store.state.id, id:this.purchased_id, rate:json1,progress:this.SaveTheProgress()}).then(res=>{
                // console.log("保存成功",this.active[0] )
                this.huoqujinduarr()//给进度数组赋值
            })
            this.$post('purchased/sumbitRate',{token:this.$store.state.id, id:this.purchased_id, rate:json1,progress:this.SaveTheProgress()}).then(res=>{
                // console.log("保存成功")
            })
        }
        // this.calculateScore()
        this.currentProgress() // 保存当前进度
       // this.CalculatingActivityProgress()//计算活动进度
        this.ComputingTask()//计算任务进度
    },
    // 保存当前活动进度进行到哪个资源
    currentProgress(){
        for(let i=0;i<this.project.length;i++){
            this.project[i].lasttime = ""
        }
        let lasttime = {
            activeIndex: this.activeIndex,
            jieIndex:this.itemIndex_bz,
            zhangIndex:this.chapterIndex_bz
        }
        // console.log("保存lasttime对象：",lasttime)
        let obj = [];
        this.project[this.taskIndex].lasttime = lasttime
        obj = this.project;
        let progress = this.SaveTheProgress()//计算项目进度
        let json1 = JSON.stringify(obj)
        this.$post('purchased/sumbitRate',{token:this.$store.state.id, id:this.purchased_id, rate:json1,progress:progress}).then(res=>{
            // console.log("保存成功")
        })
    },
    // 计算活动进度
    CalculatingActivityProgress(){
        let index = 0
        let changdu = 0
        for(let i=0;i<this.active[0].resources.length;i++){
           for(let j=0;j<this.active[0].resources[i].items.length;j++){
            if(this.active[0].resources[i].items[j].state == 2){
                index += 1
            }else{
                this.active[0].resources[i].items[j].progress ? this.active[0].resources[i].items[j].progress : this.active[0].resources[i].items[j].progress= 0
                index += Number(this.active[0].resources[i].items[j].progress)
            }
          
            changdu += 1
           }
        }
        this.ActivitySchedule = +((index / changdu * 100).toFixed(0))
        // console.log('活动进度',this.ActivitySchedule)
    },
    //计算任务进度的方法
    ComputingTask(){
        let index1 = 0
    
        if(this.project[this.taskIndex].taskState == 2){
            index1 +=1
        }else{
            let index2 = 0
            for(let j=0;j<this.project[this.taskIndex].task_activities.length;j++){
                if(this.project[this.taskIndex].task_activities[j].activeState == 2){
                    index2 +=1
                }else{
                    let index3 = 0
                    let length1 = this.project[this.taskIndex].task_activities[j].resources.length
                    let length2 = 0
                        for(let z=0;z<this.project[this.taskIndex].task_activities[j].resources.length;z++){
                        length2 = this.project[this.taskIndex].task_activities[j].resources[z].items.length
                        for(let y=0;y<this.project[this.taskIndex].task_activities[j].resources[z].items.length;y++){
                            if(this.project[this.taskIndex].task_activities[j].resources[z].items[y].progress == 1){
                                index3 +=1
                            }
                        }
                        }
                    index2 += index3 / (length1 * length2)
                }
            }
            index1 += index2 / this.project[this.taskIndex].task_activities.length
        }
       
        //console.log('计算任务进度',index1 )
        this.TaskSchedule = +((index1 * 100).toFixed(0))
    },
    //计算项目进度
    
    SaveTheProgress()
    {   
        // console.log('this.project',this.project)
        let index1 = 0
        for(let i=0 ; i< this.project.length;i++){
            if(this.project[i].taskState == 2){
                index1 +=1
            }else{
                let index2 = 0
                for(let j=0;j<this.project[i].task_activities.length;j++){
                    if(this.project[i].task_activities[j].activeState == 2){
                        index2 +=1
                    }else{
                        let index3 = 0
                        // let length1 = this.project[i].task_activities[j].resources.length
                        let length2 = 0
                         for(let z=0;z<this.project[i].task_activities[j].resources.length;z++){
                            length2 += this.project[i].task_activities[j].resources[z].items.length
                            for(let y=0;y<this.project[i].task_activities[j].resources[z].items.length;y++){
                                if(this.project[i].task_activities[j].resources[z].items[y].progress == 1){
                                    index3 +=1
                                }
                            }
                         }
                        index2 += index3 / length2
                    }
                }
                index1 += index2 / this.project[i].task_activities.length
            }
        }
        //  console.log('计算项目进度',index1 / this.project.length)
        return index1 / this.project.length

    },

    /**
     * @author  :  zgg
     * @created :  2019/06/28
     * @version :  v1.0
     * @desc    :  获取评分规则
     */
    getCodePoints(){
        this.$post('proportion/get', {
            token: this.$store.state.id,
            product_id: this.product_id,
            shop_id: this.$store.state.store.id
        }).then(res => {
            //console.log('评分规则',res.data.result.resources)
            this.proportion = JSON.parse(res.data.result.resources)
            this.circulation()//遍历大纲插入评分规则
        })
    },

    /**
     * @author  :  zgg
     * @created :  2019/06/29
     * @version :  v1.0
     * @desc    :  遍历大纲插入数据
     */
    circulation(){
        for(let i=0; i<this.project.length; i++){
            this.project[i].percentage = this.proportion[i].percentage
            for(let j=0; j<this.project[i].task_activities.length; j++){
                this.project[i].task_activities[j].percentage = this.proportion[i].task_activities[j].percentage
                for(let y=0; y<this.project[i].task_activities[j].resources.length; y++){
                    this.project[i].task_activities[j].resources[y].percentage = this.proportion[i].task_activities[j].resources[y].percentage
                    for(let z=0; z<this.project[i].task_activities[j].resources[y].items.length; z++){
                        this.project[i].task_activities[j].resources[y].items[z].percentage = this.proportion[i].task_activities[j].resources[y].items[z].percentage
                        this.project[i].task_activities[j].resources[y].items[z].rule = this.proportion[i].task_activities[j].resources[y].items[z].rule
                    }
                }
            }
        }
        // console.log('this.outline加入评分规则',this.project)
        // this.calculateScore()
    },

    //计算章进度
    CalculateChapterProgress(section){
        for(let i=0;i<section.length;i++){
            if(section[i].state !=2){
                return false//章未完成
            }
        }
        return true//章已完成
    },
    //点击更换活动
    switchoverActivity(res,index){
            this.otherLeaveVideo()//保存进度
            this.chapterIndex_bz = index
            this.itemIndex_bz=999
            for(let i=0;i<this.active[0].resources[index].items.length;i++){
                if(this.active[0].resources[index].items[i].state != 2){
                    this.itemIndex_bz=i
                    break
                }
            }
            if(this.itemIndex_bz != 999){
                this.getType()// 获取资源
            }else{
                this.type = 0
            }
            // this.getRate();
    },
    //定时器
    setTimer() {
        if(this.timer == null) {
            this.timer = setInterval( () => {
            let jindu = this.videoObj.j2s_getCurrentTime()/this.videoObj.j2s_getDuration()
            this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz].progress = jindu
            this.active[0].resources[this.chapterIndex_bz].items[this.itemIndex_bz].currentTime = this.videoObj.j2s_getCurrentTime()
            if(jindu > this.LastProgress){
                this.huoqujinduarr()//处理进度数组
                // this.otherLeaveVideo();//保存进度
                // this.setTimer()
                this.LastProgress = jindu //保存上次进度
                this.LastTimer = this.videoObj.j2s_getCurrentTime()
            }
            // console.log(this.LastProgress)
            // console.log(this.LastTimer)
            //this.CalculatingActivityProgress()//计算活动进度
            this.ComputingTask()//计算任务进度
             // 修改数组触发视图变化
            this.active.push({ message: 'Baz' })
            this.active.pop()
            //视频观看过程中 每隔30秒保存一次视频
            this.TimerBz++
            if(this.TimerBz == 30 ){
                this.TimerBz = 0
                // console.log("this.type",this.type)
                if(this.type == 1){
                    // console.log("进入定时保存函数")
                    this.otherLeaveVideo()
                    this.setTimer()
                }
            }
            //  console.log('上次进度',this.LastProgress)
            }, 1000)
        }
    },
    //查看资源播放位置
    getjindu(chaxun){
        for(let i=0 ;i<this.active[0].resources.length;i++){
            for(let j=0 ;j<this.active[0].resources[i].items.length;j++){
                if(this.active[0].resources[i].items[j].state != 2){
                    if(chaxun==null){
                        this.chapterIndex_bz=i
                        this.itemIndex_bz=j
                        // console.log('i',i)
                        // console.log('j',j)
                        this.resourceName = this.active[0].resources[i].items[j].name 
                    }
                    return false
                }
            }
        }
        // console.log('课程都已学完')
        return true
    },
    //侧边栏资源跳转
    selectResource(item,itemIndex){
           
        // console.log('侧边栏跳转参数')
        // console.log("索引",itemIndex)
        // console.log('值',item)
        // console.log(item.resources[0])
        // console.log( '音频时间', this.audioObj.currentTime)
        this.qunbukanwanBz = false  //还原全部看完标志
        // 判断类型
       this.$post('resources/get',{token: this.$store.state.id,id:item.resources[0]}).then(res=>{
            // console.log('获取类型结束')
            let type = res.data.result.type;
            if(item.state == 2 && type==1 ){
                this.$message({
                    showClose: true,
                    message: '该节资源已经观看完，请观看其他资源',
                    type: 'warning'
                  });
                  return false
            }

            this.otherLeaveVideo();//保存进度

            // 获取新点击视频的参数
            this.type= 0
            this.resourceName = item.name
            this.itemIndex_bz = itemIndex
            this.getType() //获取资源
        })

    },
     //讨论区组件传值
     closeMain(val){
        // console.log('讨论区组件传值',val) 
        this.audioBZ=val
        this.otherLeaveVideo()//保存进度
    },
    //课后习题组件传值
    exerciseMain(val){
        // console.log('课后习题组件传值',val) 
        this.exerciseBz = val
        this.otherLeaveVideo()//保存进度
    },
     //考试 区组件传值
    ClasseXam(val){
        // console.log('考试分数：',val) 
        if(val>=60){
             this.ClasseXamBZ=2
             
        }
        // console.log('考试分数：',this.ClasseXamBZ) 
    },
    //获取活动进度新数字给界面进度条显示
    huoqujinduarr(){
        this.activePlan =JSON.parse(JSON.stringify(this.active[0].resources)) 
        for(let i=0;i<this.activePlan.length;i++){
            for(let j=0;j<this.activePlan[i].items.length;j++){
                this.activePlan[i].items[j].progress ? this.activePlan[i].items[j].progress : 0
                this.activePlan[i].items[j].progress = Number((this.activePlan[i].items[j].progress * 100).toFixed(0))
            }
        }
        // console.log(' this.activePlan ', this.activePlan )
    },
    //图片放大
    tupianfagnda(){
        this.imgWidth += 10
        if( this.imgWidth > 100){
            this.imgWidth = 100
        }
        this.$refs.img.style.width=this.imgWidth+"%"  
    },
    //图片缩小
    tupiansuoxiao(){
        this.imgWidth -= 10
        if( this.imgWidth < 10){
            this.imgWidth = 10
        }
        this.$refs.img.style.width=this.imgWidth+"%"  
    },
    ////////////////////////////////////////////////////////////end:逻辑处理方法//////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////第三方组件方法//////////////////////////////////////////////////////////////
    // 进度绑定函数
    format(percentage) {
        return percentage === 100 ? '满' : `${percentage}%`;
    },
    handleOpen(key, keyPath) {
        // console.log(key, keyPath);
      },
    handleClose(key, keyPath) {
        // console.log(key, keyPath);
    },
    // 鼠标移入加入class
    changeActive($event){
            $event.currentTarget.className="el-row zzxx2";
    },
    removeActive($event){
            $event.currentTarget.className="el-row zzxx1";
    },

    ////////////////////////////////////////////////////////////end:第三方组件方法//////////////////////////////////////////////////////////////

    //创建保利威视的视频对象
    videoPlayer(url,time) {
        let currentTime = time;
        let numVal = ((1 - 140 / document.body.offsetHeight));
        let eleHeight = document.body.offsetHeight * numVal;
        
        currentTime ? currentTime : currentTime = 0;
        // isAuth == '1' ? isPlayer : isPlayer = 'off';
        this.videoObj  = polyvObject(
            "#plv_1"
        ).videoPlayer({
            width: "100%",
            
            vid: url,
            'flashvars': { "watchStartTime": currentTime, "ban_seek_by_limit_time": "off", 'ban_history_time': 'on' }
        });
        // this.videoObj = player; 
    },
    
    //关闭窗口监听事件
    // beforeunloadHandler (e) { 
    //     this.otherLeaveVideo()
    // },

    // 音频播放结束函数
    audioEnded(){
        this.otherLeaveVideo(true)//保存进度
        //  this.goNextPart()
        // console.log('音频播放完毕')
    },

    /**
    * @author  :  zgg
    * @created :  2019/06/28
    * @version :  v1.0
    * @desc    :  计算分数
    */
    calculateScore(){
        let points1 = 0
        for(let i=0; i<this.project.length; i++){
            let points2 = 0
            let project = this.project[i]
            for(let j=0; j<this.project[i].task_activities.length; j++){
                let points3 = 0
                let task_activitie = this.project[i].task_activities[j]
                for(let y=0; y<this.project[i].task_activities[j].resources.length; y++){
                    let points4 = 0
                    let resource = this.project[i].task_activities[j].resources[y]
                    for(let z=0; z<this.project[i].task_activities[j].resources[y].items.length; z++){
                        let item = this.project[i].task_activities[j].resources[y].items[z]
                        let state = item.state ? item.state : 0
                        let grade = item.grade ? item.grade : 0
                        if(state === 2 ){
                            if(grade){
                                points4 += grade
                            }else{
                                points4 += 100
                            }
                        }
                    }
                    points4 = points4/resource.items.length
                    points3 += points4 * resource.percentage/100
                }
                points2 += points3 * task_activitie.percentage/100
            }
            points1 += points2 * project.percentage/100
        }
        this.totalPoints = points1.toFixed(0)
        // console.log('分数',this.totalPoints)
        this.postSaveScore()//提交到服务器
        return points1.toFixed(0)
    },

    /**
     * @author  :  zgg
     * @created :  2019/06/28
     * @version :  v1.0
     * @desc    :  保存分数
     */
    postSaveScore(){
        if(this.totalPoints){
            this.$post('purchased/sumbitResult', {
                token:this.$store.state.id,
                score : this.totalPoints,
                id: this.purchased_id
            })
        }
    },

    /**
     * @author  :  zgg
     * @created :  2019/07/01
     * @version :  v1.0
     * @desc    :  解码
     */
    Decrypt(data){
        var CryptoJS = require("crypto-js");
        var bytes  = CryptoJS.AES.decrypt(data, '18888888888');
        var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return decryptedData
    },
    


      

    },


    //离开视频页面时候存储JSON信息到rate字段
    beforeRouteLeave(to, from, next) {
        if (to.path != '/studyhomepage') {
            this.otherLeaveVideo()
             // 每次离开当前界面时，清除定时器
             clearInterval(this.timer)
             this.timer = null
            next()
        }
    },

    created() {

        let data = this.$route.query.data
        data = this.Decrypt(data)
        this.goodsId = data.goodsId
        this.project_id = data.project_id
        this.purchased_id = data.purchased_id
        this.taskIndex = Number(data.taskState_index),
        this.activeIndex =Number(data.activeState_index)
        this.product_id = data.product_id
        // this.product_id = this.$route.query.id

        // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
        clearInterval(this.timer)
        this.timer = null
		
		//关闭窗口监听事件
		window.onbeforeunload = () => {
		    this.otherLeaveVideo()
		}
		

    },


    mounted: function () {
        let me = this;
        this.audioObj = this.$refs.audio
        this.getRate();
        this.tolessonstudy()
        
        // // if (JSON.parse(evt.data).success == 'true') {
            me.isGetVideo = 'true';
            //获取数据
            // me.getData();
            //进入页面获取视频资源
            // me.videoPlay(me.$route.query.items_resources, me.$route.query.currentTime); me.videoPlay(me.$route.query.items_resources, me.$route.query.currentTime);
            //页面标题
             document.title = this.$route.query.className;
            //关闭章节目录栏触发下面的方法使得视频大小恢复
            UIkit.util.on('#offcanvas-push', 'hide', function () {
                me.arrowIcon = !me.arrowIcon;
                document.querySelector('body').style.cssText = 'width:100%;transition: all 350ms;';
            });
            //打开章节目录改变箭头图标
            UIkit.util.on('#offcanvas-push', 'show', function () {
                me.arrowIcon = !me.arrowIcon;
            });
           document.querySelector('body').style.cssText = 'width:100%;transition: all 350ms;';
           
            //视频播放完毕触发函数
            window.s2j_onPlayOver = () =>{
              //  this.goNextPart()
              this.otherLeaveVideo(true)//保存进度
            //   console.log('视频播放完毕')
            },
            //视频播放触发函数
            window.s2j_onVideoPlay = () =>{
                // console.log('视频播放')
                this.setTimer()
            }
             //视频停止触发函数
             window.s2j_onVideoPause = () =>{
                // console.log('视频停止播放')
                clearInterval(this.timer)
                this.timer = null
                this.otherLeaveVideo()//保存进度
            }
            //注册关闭窗口监听事件
            // window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))

    },
    

}
